import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { QueryResult } from "@/api/utils/types"
import { WarrantsFilesProcessedParser } from "@/models/admin/warrantsFilesProcessed/warrantsFilesProcessed.parser"
import { IWarrantsFilesProcessed } from "@/models/admin/warrantsFilesProcessed/warrantsFilesProcessed.types"
import {
  Financials_Warrants_Files_Processed_Bool_Exp,
  Financials_Warrants_Files_Processed_Order_By,
  GetWarrantsFilesProcessedQuery,
} from "@/api/hasura/generated/graphql"

export interface WarrantsFilesProcessedListResult {
  files: IWarrantsFilesProcessed[]
  totalCount: number
}

/** "All Filters" selections applied to the DCA Files processed table. */
export interface WarrantsFilesProcessedFilters {
  /** Filter to a single warrants_files_dca_type, or null for any. */
  dcaType: string | null
  /** Filter to a single warrants_files_type, or null for any. */
  fileType: string | null
}

class WarrantsFilesProcessedServiceClass {
  getFiles(
    search: string,
    filters: WarrantsFilesProcessedFilters,
    page: number,
    pageSize: number,
    orderBy: Financials_Warrants_Files_Processed_Order_By,
  ): QueryResult<WarrantsFilesProcessedListResult> {
    const where: Financials_Warrants_Files_Processed_Bool_Exp = {
      file_name: { _ilike: `%${search}%` },
    }
    if (filters.dcaType) {
      where.dca_type = { _eq: filters.dcaType }
    }
    if (filters.fileType) {
      where.file_type = { _eq: filters.fileType }
    }

    return useQuery({
      ...HasuraQueries.warrants.filesProcessed(
        (page - 1) * pageSize,
        pageSize,
        where,
        orderBy,
      ),
      useRawResponse: true,
      placeholderData: { files: [], totalCount: 0 },
      parserFn: (
        data: GetWarrantsFilesProcessedQuery,
      ): WarrantsFilesProcessedListResult => ({
        files: data.financials_warrants_files_processed.map(
          WarrantsFilesProcessedParser.toDomain,
        ),
        totalCount:
          data.financials_warrants_files_processed_aggregate.aggregate?.count ??
          0,
      }),
    })
  }
}

export const WarrantsFilesProcessedService =
  new WarrantsFilesProcessedServiceClass()
